import {Accordion} from '@shopify/marketing-assets';
import '../../application';

document.addEventListener('DOMContentLoaded', () => {
  new Accordion(document.getElementById('featureAccordion'), {
    openFirst: false,
  });
  smoothScrolling();
  highlightNav();
});

function smoothScrolling() {
  const featureNav = document.getElementById('featureList');
  featureNav.addEventListener('click', (evt) => {
    const sectionTitle = evt.target.textContent;
    const targetAnchor = document.getElementById(sectionTitle);
    targetAnchor.scrollIntoView({
      behavior: 'smooth',
    });
  }, false);
}

function highlightNav() {
  const anchors = document.querySelectorAll('.anchor');
  const observer = new IntersectionObserver((features) => {
    features.forEach((feature) => {
      const activeLink = document.querySelector(`[data-section="${feature.target.dataset.title}"]`);
      if (feature.isIntersecting) {
        clearClass('#featureList li', 'highlight');
        activeLink.classList.add('highlight');
      }
    });
  }, {rootMargin: "0px 0px -75% 0px"});

  anchors.forEach((anchor) => {
    observer.observe(anchor);
  });
}

function clearClass(selector, className) {
  const matchingElements = document.querySelectorAll(selector);
  for (const element of matchingElements) {
    element.classList.remove(className);
  }
}
